<!-- 特色美食详情页 mjs -->
<template>
 <div class="travelServe delicacydetailContainer">

    <!-- <div class="crumbs-1">
      <div class="container">
        <a href="/show/index">首页</a>
        <span>&gt;</span>
        <a href="#">特色美食</a>
        <span>&gt;</span>
        <a href="#">详情页</a>
      </div>
    </div> -->
    <crumbs detail="true"/>
    <div class="container">
      <div class="leftPart pb100 fl bgfff">
        <div class="topCont">
          <div class="banner w320">
            <swiper :options="swiperOption" id="banner" ref="mySwiper"   class="swipercontainer">

              <!-- <div class="swiper-wrapper"> -->
                <swiper-slide class="swiper-slide" v-for="(item,index) in images" :key="index">
                 <img :src="getImage(item)"  alt="">
                </swiper-slide>

              <!-- </div> -->
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
          <div class="w400">
            <h2 class="title">{{detailParams.name}}</h2>
            <!-- <div class="iconBox">
              <span><i></i><span>11</span></span>
              <span><i></i><span>22</span></span>
              <span><i></i><span>33</span></span>
            </div> -->
            <pv :pvtype=1 :count=pv></pv>
            <div class="con">
                {{detailParams.introduction}}
            </div>
          </div>
        </div>

        <div class="dbttom">
           <div class="title">
             <span>美食指南</span><i></i>
           </div>
           <div class="contentdetail" v-html="detailParams.content">
            </div>
        </div>

       <!-- 评论 组件引入 -->
      <comment v-if="detailParams" comment-show="isCommentshow" @commentcount="commentCount" @coffsettop="cOffsettop" v-show="isCommentshow"></comment>
      </div>
      <div class="rightPart fr">
          <div class="shopRecommended" v-if="detailParams.travelShops != undefined && detailParams.travelShops.length > 0">
             <h2 class="title">商家推荐</h2>
             <ul class="shopUL">
               <li v-for="val in detailParams.travelShops" :key="val.id" @click="goshopLink(val.link)">
                 <img :src="val.image"  alt="">
                 <div class="con">
                  <h3 class="name">{{val.name}}</h3>
                  <div class="address" v-html="val.introduction"></div>
                 </div>
               </li>
             </ul>
          </div>
          <div class="foodRecommend">
             <h2 class="title">推荐美食</h2>
             <ul class="foodUl">
               <li v-for="item in delicacylist" :key="item.id" v-if="item.id != id" @click="gotodetail(item.id)">
                  <img :src="getImage(item.image)"  alt="">
                 <h3 class="name">{{item.name}}</h3>
               </li>
             </ul>
          </div>

      </div>

    </div>
    <right-sidebar
     @pvcount="pvcount"
     :comment-count="commentTotal"
     :comment-gotop="commentOffsettop"
     :comment-show="isCommentshow"
      :title="detailParams.name"
      :image="getImage(detailParams.image)"
      :url="this.$route.fullPath"
      ref="rightSidebar"></right-sidebar>
       <go-top></go-top>

 </div>
</template>

<script>
import crumbs from '@/components/crumbs/index'
import pv from '@/components/amount/pv'
import {getdelicacyList, getdelicacyDetail} from '@/api/delicacy/index'
import Comment from '@/components/comment/index'
import RightSidebar from '@/components/rightsidebar/index'
import goTop from '@/components/gotop/index'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  name: 'delicacydetail',
  components: {
    Comment,
    goTop,
    RightSidebar,
    pv,
    crumbs,
    swiper,
    swiperSlide
  },
  meta: {
    showHeader: true
  },
  data () {
    return {
      isCommentshow: true,
      commentTotal: '',
      commentOffsettop: '',
      swiperOption: {
        pagination: {
          el: '#banner .swiper-pagination'
        },
        autoplay: {
          delay: 4000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        observer: true,
        observeParents: true
      },
      id: '',
      detailParams: {},
      images: [],
      pv: 0,
      recommend: {},
      menu: '',
      delicacyParam: {
        page: 1,
        limit: 10,
        menuId: '6146',
        types: '',
        areaType: '',
        foodType: ''
      },
      delicacylist: []
    }
  },
  created () {
    this.menu = this.$route.query.columnId
    this.delicacyParam.menuId = this.$route.query.columnId
    this.phoneNum = this.$cookie.get('wlymobilephone')
    this.id = this.$route.query.id
    this.getdelicacylist()
    this.getDetail()
    // this.recommend = this.$route.query.info
  },
  methods: {
    goshopLink (val) {
      window.open(val)
    },
    gotodetail (id) {
      this.$router.push({
        path: '/delicacydetail',
        query: {
          id: id,
          columnId: this.menu
        }
      })
    },
    getdelicacylist () {
      getdelicacyList(this.delicacyParam).then(res => {
        console.log(res, 'mjs')
        this.delicacylist = res.data.list.data.rows
      })
    },
    getDetail () {
      getdelicacyDetail(this.id).then(res => {
        // console.log(res, 'mjs')
        this.detailParams = res.data.data
        this.images = this.detailParams.images.split('|')
      })
    },
    commentCount (val) {
      this.commentTotal = val
    },
    cOffsettop (val) {
      this.commentOffsettop = val
    },
    pvcount (val) {
      this.pv = val
    },
    getImage (val) {
      if (val === undefined) {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    }
    // gotofood (id) {
    //   this.$router.push({
    //     path: '/delicacydetail',
    //     query: {
    //       id: id,
    //       columnId: this.menu
    //     }
    //   })
    // }
  },
  beforeDestroy () {

  }
}

</script>

<style lang='scss' scoped>

@import "../../assets/common/scss/travleServes.scss";
.dbttom .contentdetail{
  p{
    img{
    width: 100% !important;
  }
  }

}
</style>



// WEBPACK FOOTER //
// src/view/delicacy/detail.vue